import classNames from 'classnames';
import * as React from 'react';
import { CSSProperties, ReactNode } from 'react';

interface ISectionContainerProps {
  id?: string;
  className?: string;
  style?: CSSProperties;
  fill?: 'solid' | 'gradient';
  padding?: 'top' | 'bottom' | 'none' | 'all';
  noGutter?: boolean;
  contentClassName?: string;
  dataModule: string;
  children: ReactNode;
  display?: boolean;
}

/** Wrapper for adding classes and Refs */
export const SectionContainer = React.forwardRef<HTMLDivElement, ISectionContainerProps>(function Container(
  {
    id,
    className,
    style,
    fill,
    padding,
    children,
    noGutter,
    contentClassName = 'Container-inner',
    dataModule,
    display = true,
  },
  ref: React.Ref<HTMLDivElement>,
) {
  const innerContainerClasses = classNames(contentClassName, {
    'u-pL-0 u-pR-0': noGutter,
    [`Container--blue`]: fill === 'solid',
    [`Container--blue--gradient`]: fill === 'gradient',
    'u-pT-responsive': ['top', 'all'].includes(padding as string),
    'u-pB-responsive': ['bottom', 'all'].includes(padding as string),
  });

  if (display) {
    return (
      <div data-module={dataModule} id={id} className={className} style={style} ref={ref}>
        <div className={innerContainerClasses}>{children}</div>
      </div>
    );
  }

  return null;
});
